import {createSelector} from "@reduxjs/toolkit";

export const partnerFeaturesSelector = createSelector(state => state.manager.partnerFeatures, partnerFeatures => {
    return partnerFeatures;
});

export const getPartnerPaymentDetailsSelector = createSelector(state => state.manager.partnerPaymentDetails, (partnerPaymentDetails) => {
    // related to https://bllink.atlassian.net/browse/SSB-2055
    return partnerPaymentDetails;
});